import {
    COMMON_CODE_LENGTH,
    COMMON_CODE_PADDING_CHAR,
    COMMON_CODE_REGEX,
    ISIN_REGEX,
    ISIN_SEPARATOR,
    LAST_COMMA_REGEX,
    MAX_ISINS_FOR_SINGLE_ISIN_REPORT
} from "../constants/REPORTS";
import { IIsinOKCheck } from "../views/components/IsinTextField/IsinTextField";

const isISINOK = (isin: string): boolean => {
    const ret = isin?.match(ISIN_REGEX) !== null;
    return ret;
};

const isCommonCodeOK = (code: string): boolean => {
    const ret = code?.match(COMMON_CODE_REGEX) !== null;
    return ret;
};

const padCommonCode = (code: string): string => {
    return code.padStart(COMMON_CODE_LENGTH, COMMON_CODE_PADDING_CHAR); // common code must have length 9
};

export const isContentOK = (text: string): IIsinOKCheck => {
    text = text?.replace(LAST_COMMA_REGEX, "");
    
    const isins = text?.split(ISIN_SEPARATOR)?.map(i => i.trim());

    const areAllIsinsOK = isins?.every(i => isISINOK(i) || isCommonCodeOK(i));
    const isIsinsLimitOK = isins?.length <= MAX_ISINS_FOR_SINGLE_ISIN_REPORT;
    const result = isIsinsLimitOK && areAllIsinsOK;
    const ret: IIsinOKCheck = {
        result,
        ...(result && {
            isins: isins?.map(i => padCommonCode(i))
        }),
        error: !areAllIsinsOK ? "INCORRECT_FORMAT" : !isIsinsLimitOK ? "MAX_ISIN_EXCEEDED" : null
    };

    return ret;
};
